/* SKINGRAPHICA redesign, By invitation. Founder codes are real Shopify discount codes.
   check() asks the public Storefront API about 2 throwaway carts (never the shopper's bag):
   cart A holds 1 of every product, cart B holds only the lowest priced one.
   Prices across the store are redrawn only when the code is a plain percentage that applies to every product with no minimum,
   so a shown price is always the price checkout charges. Any other live code is still attached to the bag for checkout.
   State lives in localStorage sg-inv. Source scratchpad/rd/src/assets/sg-inv.js */
(function () {
  'use strict';
  var KEY = 'sg-inv';
  function get() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function put(s) { try { if (s) localStorage.setItem(KEY, JSON.stringify(s)); else localStorage.removeItem(KEY); } catch (e) {} }

  function gql(cfg, query, vars) {
    return fetch('/api/' + (cfg.api || '2025-07') + '/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': cfg.token },
      body: JSON.stringify({ query: query, variables: vars })
    }).then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); });
  }
  var CART = 'cart{discountCodes{code applicable} cost{subtotalAmount{amount}} discountAllocations{discountedAmount{amount}} lines(first:60){nodes{merchandise{... on ProductVariant{id product{handle}}} cost{subtotalAmount{amount}} discountAllocations{discountedAmount{amount}}}}}';
  function Q(cc, two) {
    var v = '$a:CartInput!' + (two ? ',$b:CartInput!' : '') + (cc ? ',$cc:CountryCode!' : '');
    return 'mutation(' + v + ')' + (cc ? ' @inContext(country:$cc)' : '') + '{a:cartCreate(input:$a){' + CART + ' userErrors{message}}' + (two ? ' b:cartCreate(input:$b){' + CART + ' userErrors{message}}' : '') + '}';
  }

  function probes(cfg) {
    return String(cfg.probe || '').split(',').filter(Boolean).map(function (x) { var p = x.split(':'); return { id: 'gid://shopify/ProductVariant/' + p[0], c: Number(p[1]) || 0, h: p[2] || '' }; });
  }
  function sum(list) { return (list || []).reduce(function (n, a) { return n + Number(a.discountedAmount.amount); }, 0); }
  function off(cart) {
    /* share of each line taken off, counting line and order level savings */
    var sub = Number(cart.cost.subtotalAmount.amount) || 0, order = sum(cart.discountAllocations), out = [];
    cart.lines.nodes.forEach(function (l) {
      var ls = Number(l.cost.subtotalAmount.amount) || 0;
      if (!ls) return;
      var mine = sum(l.discountAllocations) + (sub ? order * ls / sub : 0);
      var m = l.merchandise || {};
      out.push({ r: mine / ls, id: m.id || '', h: (m.product && m.product.handle) || '' });
    });
    return out;
  }
  function applies(cart, code) {
    return (cart.discountCodes || []).some(function (d) { return d.applicable && d.code.toUpperCase() === code.toUpperCase(); });
  }
  function input(code, lines, cfg) {
    var o = { discountCodes: [code], lines: lines.map(function (p) { return { merchandiseId: p.id, quantity: 1 }; }) };
    if (cfg.cc) o.buyerIdentity = { countryCode: cfg.cc };
    return o;
  }

  /* resolves {ok:true, pct, all, ex} or {ok:false, why:'invalid'|'setup'|'network'}
     28 Oct 2026: a code that leaves some products out (for example a code set on the Shop All collection, which does not hold LEGACY)
     still reprices the store. The products it leaves out are listed in ex and keep their full price on the shelf */
  function check(code, cfg) {
    if (!cfg || !cfg.token) return Promise.resolve({ ok: false, why: 'setup' });
    var ps = probes(cfg);
    if (!ps.length) return Promise.resolve({ ok: false, why: 'setup' });
    var vars = { a: input(code, ps, cfg) }; if (cfg.cc) vars.cc = cfg.cc;
    function bad(r) { return { ok: false, why: /access|token|unauthor/i.test(JSON.stringify(r.errors)) ? 'setup' : 'network' }; }
    return gql(cfg, Q(cfg.cc, false), vars).then(function (r) {
      if (r.errors && r.errors.length) return bad(r);
      var A = r.data && r.data.a && r.data.a.cart;
      if (!A || !applies(A, code)) return { ok: false, why: 'invalid' };
      var ra = off(A), hit = ra.filter(function (x) { return x.r > 0.003; });
      if (!hit.length) return { ok: true, pct: 0, all: false, ex: [] };
      var p = hit[0].r;
      var flat = p > 0 && p < 1 && hit.every(function (x) { return Math.abs(x.r - p) < 0.006; });
      var ex = ra.filter(function (x) { return x.r <= 0.003; }).map(function (x) { return x.h; }).filter(Boolean);
      var pct = Math.round(p * 1000) / 10;
      if (!flat) return { ok: true, pct: 0, all: false, ex: [] };
      /* a minimum spend shows up as no saving on the cheapest product the code covers on its own */
      var ids = hit.map(function (x) { return x.id; });
      var low = ps.filter(function (x) { return ids.indexOf(x.id) > -1; }).sort(function (x, y) { return x.c - y.c; })[0];
      if (!low) return { ok: true, pct: pct, all: true, ex: ex };
      var v2 = { a: input(code, [low], cfg) }; if (cfg.cc) v2.cc = cfg.cc;
      return gql(cfg, Q(cfg.cc, false), v2).then(function (r2) {
        var B = r2.data && r2.data.a && r2.data.a.cart;
        var rb = B && applies(B, code) ? off(B) : [];
        var ok = rb.length && Math.abs(rb[0].r - p) < 0.006;
        return { ok: true, pct: ok ? pct : 0, all: !!ok, ex: ok ? ex : [] };
      });
    }).catch(function () { return { ok: false, why: 'network' }; });
  }

  /* attach the code to the shopper's bag so checkout applies it */
  function attach(code) {
    var body = JSON.stringify({ discount: code });
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (c) {
        return fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' }).catch(function () {}).then(function () {
          try { document.dispatchEvent(new CustomEvent('sg:cart', { detail: c || {} })); } catch (e) {}
          return c;
        });
      });
  }
  function detach() {
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: '' }) })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
      .then(function (c) { try { document.dispatchEvent(new CustomEvent('sg:cart', { detail: c || {} })); } catch (e) {} });
  }
  function save(code, res, cfg) {
    var s = { code: code, pct: res.pct, all: res.all, ex: res.ex || [], cc: cfg.cc, cur: cfg.cur, t: Date.now(), cfg: { token: cfg.token, api: cfg.api, probe: cfg.probe } };
    put(s);
    return s;
  }
  function clear() { put(null); document.documentElement.classList.remove('sg-inv-on'); return detach(); }

  /* re-check a saved code once a visit, or when the shopper changes country */
  function recheck(cc) {
    var s = get();
    if (!s || !s.code || !s.cfg) return Promise.resolve(s);
    var cfg = { token: s.cfg.token, api: s.cfg.api, probe: s.cfg.probe, cc: cc || s.cc, cur: s.cur };
    return check(s.code, cfg).then(function (r) {
      if (r.ok) { s = save(s.code, r, cfg); return attach(s.code).then(function () { return s; }); }
      if (r.why === 'invalid') return clear().then(function () { return null; });
      return s;
    });
  }

  window.SGINV = { get: get, check: check, attach: attach, clear: clear, recheck: recheck };
  try { document.dispatchEvent(new CustomEvent('sg:inv-ready')); } catch (e) {}

  /* the page */
  function page() {
    var root = document.getElementById('inv'), cfgEl = document.getElementById('inv-cfg');
    if (!root || !cfgEl) return;
    var cfg = {}; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) {}
    var form = root.querySelector('[data-inv-form]'), inp = root.querySelector('[data-inv-in]'), msg = root.querySelector('[data-inv-msg]');
    var go = root.querySelector('[data-inv-go]'), goT = root.querySelector('[data-inv-go-t]');
    var vForm = root.querySelector('[data-inv-form-view]'), vOk = root.querySelector('[data-inv-ok-view]');
    function say(t, err) { msg.textContent = t || ''; msg.classList.toggle('is-err', !!err); inp.setAttribute('aria-invalid', err ? 'true' : 'false'); }
    function busy(on) { go.setAttribute('aria-busy', on ? 'true' : 'false'); goT.textContent = on ? 'Checking your code' : 'Unlock my prices'; }
    function show(s) {
      var on = !!(s && s.code);
      vForm.hidden = on; vOk.hidden = !on;
      if (!on) return;
      var big = root.querySelector('[data-inv-pct]'), h = root.querySelector('[data-inv-ok-h]'), p = root.querySelector('[data-inv-ok-p]'), n = root.querySelector('[data-inv-ok-note]');
      root.querySelector('[data-inv-code]').textContent = s.code;
      if (s.all && s.pct) {
        big.innerHTML = ''; big.appendChild(document.createTextNode(String(s.pct).replace(/\.0$/, '') + '%'));
        var sm = document.createElement('small'); sm.textContent = 'off'; big.appendChild(sm);
        h.textContent = 'Your founder pricing is on.';
        p.textContent = 'Every price across the store now shows your private price, and your code is already in your bag for checkout.';
        var exn = (s.ex || []).map(function (h) { return h.replace(/-/g, ' ').toUpperCase(); });
        n.firstChild.textContent = 'Applies to every product except gift cards' + (exn.length ? ' and ' + exn.join(' and ') : '') + '. Code ';
      } else {
        big.textContent = '';
        h.textContent = 'Your founder code is ready.';
        p.textContent = 'Your code is in your bag and your saving is applied at checkout.';
        n.firstChild.textContent = 'Code ';
      }
    }
    var q = new URLSearchParams(location.search).get('code');
    show(get());
    if (q && !get()) { inp.value = q.toUpperCase(); setTimeout(function () { form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); }, 60); }
    inp.addEventListener('input', function () { inp.value = inp.value.toUpperCase().replace(/\s+/g, ''); if (msg.classList.contains('is-err')) say(''); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = inp.value.trim().toUpperCase();
      if (!code) { say('Enter the code you were given.', true); inp.focus(); return; }
      busy(true); say('');
      check(code, cfg).then(function (r) {
        if (!r.ok) {
          busy(false);
          if (r.why === 'invalid') say('That code isn’t active. Please check it with the person who gave it to you.', true);
          else if (r.why === 'setup') say('Founder codes open very soon. Please try again shortly.', true);
          else say('We couldn’t check your code just now. Please try again in a moment.', true);
          return;
        }
        var s = save(code, r, cfg);
        return attach(code).then(function () {
          busy(false);
          document.documentElement.classList.add('sg-inv-on');
          try { document.dispatchEvent(new CustomEvent('sg:inv', { detail: s })); } catch (e2) {}
          show(s);
          vOk.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      });
    });
    root.querySelector('[data-inv-reset]').addEventListener('click', function () {
      clear().then(function () {
        try { document.dispatchEvent(new CustomEvent('sg:inv', { detail: null })); } catch (e) {}
        show(null); inp.value = ''; inp.focus();
      });
    });
  }
  if (document.readyState !== 'loading') page(); else document.addEventListener('DOMContentLoaded', page);
})();
